/**
 * The dip-chip step, in a browser: it says where the step happens. The card is
 * read on the partner's terminal (`./dipChip`), which advances the flow from
 * there; this screen offers nothing to press because nothing here can read it.
 */
import { useTranslation } from 'react-i18next';

export function DipChipStep() {
  const { t } = useTranslation();
  return (
    <>
      <h1 className="step-title">{t('flow.dipChip.title')}</h1>
      <p className="step-text" data-testid="dip-chip-at-terminal">
        {t('flow.dipChip.atTerminal')}
      </p>
    </>
  );
}
